import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { newDatePickerTokens } from '../../../../../tokens/components/NewDatePicker/tokens';
import { getMomentDate, getLocalizedDay } from '../../helpers';
import CustomText from '../../../../Typography/CustomText/CustomText';
import { CustomDate } from '../CalendarShortcuts/CalendarShortcuts';
import { DateMask } from '../Calendar';

const Header = styled.th`
  background-color: ${newDatePickerTokens.HeaderBackgroundColorBaseDefault};
  padding: 11px 0;
`;

export interface CalendarHeaderProps {
  dateMask: DateMask;
  selectedDate: CustomDate;
  'aria-label'?: string;
}

function CalendarHeader(props: CalendarHeaderProps) {
  const { selectedDate, dateMask } = props;

  // this is hard coded because the datepicker currently doesn't support i18, but once it does just change this line to:
  // const locale = locale || window.navigator.language || 'en-US';
  const locale = 'en-US';

  const defineHeaderColor = (index: number) => {
    return index === 0 || index === 6 ? 'gray' : 'black';
  };

  const startDate = getMomentDate(selectedDate, dateMask).startOf('week').format();

  const days = Array.from({ length: 7 }).map((_, index) => (
    <Header key={index}>
      <CustomText as="div" size="xsmall" align="center" color={defineHeaderColor(index)}>
        {getLocalizedDay(moment(startDate).add(index, 'day').toDate(), locale)}
      </CustomText>
    </Header>
  ));

  return <tr aria-label={props['aria-label']}>{days}</tr>;
}

export default CalendarHeader;
